import React from "react";
 import FilterList from "../../../components/user/relief/reliefFilterList/reliefFilterList.container";
import Layout from "../../../components/layouts/verticalLayout";

const ReliefListPage = (props) => {
  return <Layout body={<FilterList/>} />;
};

ReliefListPage.propTypes = {};

export default ReliefListPage;
